import { put, takeEvery, call } from 'redux-saga/effects';
import Axios from 'axios';
import { message } from 'antd';

import Actions from '../action';
import { appConstant, apiUrl } from '@constants';
import { getAuthToken, getAuthKey, history } from '@helpers';

const authToken = getAuthToken();
const authKey = getAuthKey();

export function* appWorker(action) {
	try {
		const uri = `${appConstant.domain}${apiUrl.GET_USER}${authKey}`;
		const res = yield call(Axios.get, uri);
		if (res.data.success) {
			yield put(
				Actions.creators.setUser({
					...res.data.messages,
					profileImage: (res.data.messages && res.data.messages.profileImage) || 'https://vanderhydelawsuitattorney.com/images/avatar.png',
				})
			);
		}
	} catch (err) {
		let mes = err.toString(err) === 'Error: Request failed with status code 400' ? appConstant.userNotExist : 'Something went wrong';
		message.error(mes);
		localStorage.removeItem('authKey');
		localStorage.removeItem('authToken');
		yield put(Actions.creators.getUser());
	}
}

export function* appWorkerLogoutUser(action) {
	try {
		const uri = `${appConstant.domain}${apiUrl.LOGUT}${action.authKey}`;
		const { history } = action;
		yield put(Actions.creators.resetValues());
		if (history) yield history.push('/login');
		yield localStorage.removeItem('authKey');
		yield localStorage.removeItem('messages');
		yield localStorage.removeItem('authToken');
		yield localStorage.removeItem('userDetails');
		yield localStorage.removeItem('userName');
		yield localStorage.removeItem('password');
		yield localStorage.removeItem('ipAddress');
		const res = yield call(Axios.post, uri, { headers: { Authorization: authToken } });
	} catch (err) {
		let mes = err.toString(err) === 'Error: Request failed with status code 400' ? appConstant.userNotExist : 'Something went wrong';
		message.error(mes);
		// yield put(Actions.creators.getUser());
	}
}

export default function* appWatcher() {
	yield takeEvery(Actions.types.APP_STARTED, appWorker);
	yield takeEvery(Actions.types.REMOVE_USER, appWorkerLogoutUser);
}
